import React from "react";

function ProductDescription({
    formData,
    handleChange
}) {

    return (

        <div className="card mb-3">

            <div className="card-header">
                <h5>Description</h5>
            </div>

            <div className="card-body">

                <textarea
                    rows={5}
                    className="form-control"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    placeholder="Enter Product Description"
                />

            </div>

        </div>

    );

}

export default ProductDescription;